import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-2e1f0434"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "home-footer"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "Copyright © 2017-2018", -1);
});
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, " | 京公网安备11010802026814号 京ICP备17052426号-2 京网文 [2018] 4745-385号", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_button = _resolveComponent("a-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_button, {
    href: "https://beian.miit.gov.cn/",
    target: "_blank",
    rel: "noopener",
    type: "link"
  }, {
    default: _withCtx(function () {
      return [_hoisted_2, false ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 北京聪明核桃教育科技有限公司")) : _createCommentVNode("", true), _hoisted_4];
    }),
    _: 1
  })]);
}